export default __webpack_public_path__ + "static/media/logo4.de5db293.png";